/* COVA collection tabs: tab switching, one drifting slider per tab, price chip that follows the pointer */
(function () {
  'use strict';
  function ready(fn) { if (window.CV && window.CV.register) fn(); else window.addEventListener('load', fn); }
  ready(function () {
    CV.register('[data-cv-tabs]', function (root) {
      var tabs = root.querySelectorAll('[data-cv-tab]');
      var panels = root.querySelectorAll('[data-cv-panel]');
      var drift = root.getAttribute('data-drift') === 'true';
      var speed = (parseFloat(root.getAttribute('data-speed')) || 8) * 1000;
      var visible = false;

      function build(panel) {
        var el = panel.querySelector('[data-cv-ct-slider]');
        if (!el || el.swiper) return el && el.swiper;
        var slides = el.querySelectorAll('.swiper-slide').length;
        var opts = {
          slidesPerView: 1.2, spaceBetween: 18, slidesOffsetBefore: 14, loop: slides > 5, speed: speed, grabCursor: true,
          breakpoints: { 768: { slidesPerView: 4.1, slidesOffsetBefore: 34.24 } }
        };
        if (drift) opts.autoplay = { delay: 0, disableOnInteraction: false, pauseOnMouseEnter: true };
        var sw = window.Swiper ? new window.Swiper(el, opts) : null;
        if (sw && sw.autoplay && !visible) sw.autoplay.stop();
        return sw;
      }
      function show(id) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-cv-tab') === id;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-cv-panel') === id;
          p.hidden = !on;
          p.classList.toggle('is-active', on);
          p.classList.remove('is-entering');
          if (on) {
            var el = p.querySelector('[data-cv-ct-slider]');
            if (el && el.swiper) { el.swiper.update(); } else { build(p); }
            p.querySelectorAll('.swiper-slide').forEach(function (s, i) { s.style.setProperty('--n', i); });
            void p.offsetWidth;
            p.classList.add('is-entering');
          } else {
            var other = p.querySelector('[data-cv-ct-slider]');
            if (other && other.swiper && other.swiper.autoplay) other.swiper.autoplay.stop();
          }
        });
      }
      tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-cv-tab')); }); });
      var first = root.querySelector('[data-cv-panel]:not([hidden])');
      if (first) build(first);

      // drift only while the section is on screen
      if (drift && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          var active = root.querySelector('[data-cv-panel]:not([hidden]) [data-cv-ct-slider]');
          var sw = active && active.swiper;
          if (sw && sw.autoplay) { if (visible) sw.autoplay.start(); else sw.autoplay.stop(); }
        }, { threshold: 0.2 }).observe(root);
      }

      // price chip follows the pointer over a card
      root.querySelectorAll('[data-cv-chip]').forEach(function (card) {
        card.addEventListener('mouseenter', function () { card.classList.add('is-chip'); });
        card.addEventListener('mouseleave', function () { card.classList.remove('is-chip'); });
        card.addEventListener('mousemove', function (e) {
          var r = card.getBoundingClientRect();
          card.style.setProperty('--chip-x', Math.round(e.clientX - r.left + 14) + 'px');
          card.style.setProperty('--chip-y', Math.round(e.clientY - r.top + 14) + 'px');
        });
      });
    });
  });
})();
